import { Component, Input, OnInit } from '@angular/core';
import { interrupt } from 'd3-transition';
@Component({
  selector: 'app-pa',
  templateUrl: './pa.component.html',
  styleUrls: ['./pa.component.scss']
})
export class PageAnalyzerComponent implements OnInit {
  @Input() data: any;
  constructor() { }
  ngOnInit() {

  }
}
